import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { map, catchError, delay } from "rxjs/operators";
import { of, BehaviorSubject, throwError } from "rxjs";
import { UserManagerService } from "./api";




@Injectable({
  providedIn: "root",
})
export class JwtAuthService {
  token: string = "";
  refreshToken:string = ""
  isAuthenticated: Boolean = false;
  user:  any= {};
  user$ = (new BehaviorSubject<any>(this.user));
  return: string = "";
  JWT_TOKEN = "JWT_TOKEN";
  APP_USER = "MERLIN_USER";
  timeout:boolean = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: UserManagerService
  ) {
    this.route.queryParams
      .subscribe(params => this.return = params['return'] || '/');
  }

  public signin(username:string, password:string) {

    // FOLLOWING CODE SENDS SIGNIN REQUEST TO SERVER

     return this.service.userManagerGetLoggedInUserInfoGet()
       .pipe(
         map((res: any) => {
           this.setUserAndToken(res.token, res.user, !!res);
           this.timeout = false;
           return res;
         }),
         catchError((error) => {
           return throwError(error);
         })
       );
  }

  /*
    checkTokenIsValid is called inside constructor of
    shared/components/layouts/admin-layout/admin-layout.component.ts
  */
  public checkTokenIsValid() {
        
    /*
      The following code get user data and jwt token is assigned to
      Request header using token.interceptor
      This checks if the existing token is valid when app is reloaded
    */

    // return this.http.get(`${environment.apiURL}/api/users/profile`)
    //   .pipe(
    //     map((profile: User) => {
    //       this.setUserAndToken(this.getJwtToken(), profile, true);
    //       return profile;
    //     }),
    //     catchError((error) => {
    //       this.signout();
    //       return of(error);
    //     })
    //   );
  }

  public signout() {
    this.setUserAndToken("", null, false);
    this.router.navigateByUrl("public/login");
  }

  isLoggedIn(): Boolean {
   var loggedIn =  !!this.getJwtToken();
   if(loggedIn){
     this.user = this.getUser();
   }
   return loggedIn;
  }

  getJwtToken():string|null {
    return localStorage.getItem(this.JWT_TOKEN);
  }
  getUser() {
    if (localStorage.getItem(this.APP_USER) != null) {
      return JSON.parse(localStorage.getItem(this.APP_USER) + "");
    } else {
      return {}
    }
    
  }

  setUserAndToken(token: string|null, user: any|null, isAuthenticated: Boolean) {
    this.isAuthenticated = isAuthenticated;
    this.token = token??"";
    this.user = user ?? {};
    this.user$.next(user ?? {});
    localStorage.setItem(this.JWT_TOKEN, token??"");
    localStorage.setItem(this.APP_USER,JSON.stringify(user));
  }
}
